// write a CRUD for playlist use zustand

import { create } from 'zustand';

const usePlaylistStore = create((set) => ({
  unlimitedPlaylists: [],
  setUnlimitedPlaylists: (unlimitedPlaylists) => set(() => ({ unlimitedPlaylists })),
  addUnlimitedPlaylists: (playlist) => set((state) => ({ unlimitedPlaylists: [playlist, ...state.unlimitedPlaylists] })),
  removeUnlimitedPlaylist: (id) => set((state) => ({ unlimitedPlaylists: state.unlimitedPlaylists.filter((item) => item.id !== id) })),
  // addPlaylist: (playlist) => set((state) => ({ playlist: [...state.playlist, playlist] })),
  // updatePlaylist: (id, playlist) => set((state) => ({ playlist: state.playlist.map((item) => (item.id === id ? playlist : item)) })),
  radioPlaylists: [],
  setRadioPlaylists: (radioPlaylists) => set(() => ({ radioPlaylists })),
  addRadioPlaylists: (playlist) => set((state) => ({ radioPlaylists: [playlist, ...state.radioPlaylists] })),
  removeRadioPlaylist: (id) => set((state) => ({ radioPlaylists: state.radioPlaylists.filter((item) => item.id !== id) })),

  selectedPlaylist: [],
  setSelectedPlaylist: (selectedPlaylist) => set(() => ({ selectedPlaylist })),
  addSelectedPlaylist: (playlist) => set((state) => ({ selectedPlaylist: [...state.selectedPlaylist, playlist] })),
  removeSelectedPlaylist: (id) => set((state) => ({ selectedPlaylist: state.selectedPlaylist.filter((item) => item.id !== id) })),
}));

export default usePlaylistStore;

